var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindSpeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3225_16816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 101,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6171 31.6599C75.9933 30.9527 77.0067 30.9527 77.3829 31.6599L126.381 123.78C126.735 124.446 126.252 125.25 125.498 125.25H27.5021C26.7476 125.25 26.2649 124.446 26.6192 123.78L75.6171 31.6599Z",
    fill: "#D8B4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3225_16816)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3225_16816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.98 104.365C121.981 109.85 110.404 84.0211 96.9404 89.9482C92.4531 91.9237 93.9606 98.6172 99.9444 96.3952",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5061 97.6226C95.5074 103.108 85.459 76.8389 71.9957 82.766C67.5084 84.7415 69.0159 91.435 74.9997 89.213",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3666 73.018C101.089 77.4358 92.3226 55.8835 80.5037 60.7729C76.5645 62.4026 77.8747 67.896 83.1269 66.0615",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9801 73.3652C97.9801 74.3652 92.4801 99.3652 79.48 99.3652",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.98 105.865C95.481 95.652 91.2297 127.486 77.3729 121.066C72.7544 118.926 73.7817 110.551 79.911 112.895",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3293 119.908C111.496 124.061 106.372 105.63 99.7768 109.69C97.5787 111.044 98.3656 115.734 101.299 114.217",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 52C57.76 52 71.15 52 77 52",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 118C35.76 118 49.15 118 55 118",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 106C115.76 106 129.15 106 135 106",
    stroke: "#6CCFC9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.618 14.6507C75.9947 13.9457 77.0053 13.9457 77.382 14.6507L140.233 132.279C140.589 132.945 140.106 133.75 139.351 133.75H13.6492C12.894 133.75 12.4113 132.945 12.7672 132.279L75.618 14.6507Z",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_16816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 97,
    fill: "white",
    transform: "translate(25 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeed);
export default __webpack_public_path__ + "static/media/wind_speed.6b49df1444305c5f62c3284ae3617251.svg";
export { ForwardRef as ReactComponent };